import type { ISidebarStatusRepository } from "@src/domain/repositories/sidebar";

/**
 * Sidebar status use case – get and set collapsed state - single abstraction over repository.
 */
export class SidebarStatusUseCase {
  private readonly sidebarStatusRepository: ISidebarStatusRepository;

  constructor(sidebarStatusRepository: ISidebarStatusRepository) {
    this.sidebarStatusRepository = sidebarStatusRepository;
  }

  async getCollapsed(): Promise<boolean> {
    try {
      return await this.sidebarStatusRepository.getCollapsed();
    } catch (error) {
      console.error("SidebarStatusUseCase.getCollapsed failed:", error);
      return false;
    }
  }

  getCollapsedSync(): boolean {
    return this.sidebarStatusRepository.getCollapsedSync();
  }

  async resetCollapsed(): Promise<void> {
    try {
      await this.sidebarStatusRepository.resetCollapsed();
    } catch (error) {
      console.error("SidebarStatusUseCase.resetCollapsed failed:", error);
    }
  }

  async setCollapsed(collapsed: boolean): Promise<void> {
    try {
      await this.sidebarStatusRepository.setCollapsed(collapsed);
    } catch (error) {
      console.error("SidebarStatusUseCase.setCollapsed failed:", error);
      throw new Error("Failed to persist sidebar state");
    }
  }
}
